"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTabs = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _TabsMixin = require("../../mixins/components/TabsMixin");
var StyledTabs = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledTabs",
  componentId: "c11n-8-107-0__sc-shmpg5-0"
})(["", ""], _TabsMixin.TabsMixin);
exports.StyledTabs = StyledTabs;